import { lazy, useState } from "react";
import PropTypes from "prop-types";
import { Button, Tab, Paper } from "@mui/material";

import StepTilaus from "./TabTilaus/TabTilaus";
import KeikkaConnectedIcon from "src/components/icons/purposed/KeikkaConnectedIcon";
import EdgeDrawer from "src/components/Drawer/EdgeDrawer";
import { showPumiFiAttachments } from "src/data/ifs/showIfs";
import EdgeDrawerIcon from "src/components/icons/EdgeDrawerIcon";

import KuvaTabText from "./TabKuvat/components/KuvaTabText";
import TilausTabText from "./TabTilaus/components/TilausTabText";

import { useNavigate } from "react-router-dom";
import { useToimitusData } from "src/context/ToimitusContext";
import { useTarjousData } from "src/context/TarjousContext";
import { useKeikkaData } from "src/context/KeikkaDataContext";
import { useUserData } from "src/context/userContext";
import { useStepLogData } from "src/context/StepLogContext";
import { useNavData } from "src/context/navContext";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
import { TabPanel, a11yProps } from "src/components/js/Statics.jsx";
import MyTabs from "src/components/layout/MyTabs/MyTabs";

const DeleteKeikkaIcon = lazy(() => import("src/components/icons/purposed/DeleteKeikkaIcon"));
const TabToimitus = lazy(() => import("./TabToimitus/TabToimitus"));
// import { DeleteKeikkaIcon } from "src/components/icons/purposed/DeleteKeikkaIcon";
// import TabToimitus from "./TabToimitus/TabToimitus";
const ProcessTabText = lazy(() => import("./TabKuvat/components/ProcessTabText"));
const ToiminnotTabText = lazy(() => import("./TabTilaus/components/ToiminnotTabText"));
const ToimitusTabText = lazy(() => import("./TabTilaus/components/ToimitusTabText"));
const HintaTabText = lazy(() => import("./TabTilaus/components/HintaTabText"));
const AsetuksetTabText = lazy(() => import("./TabAsetukset/AsetuksetTabText"));

const TabTarjous = lazy(() => import("./TabTarjous/TabTarjous"));
const TarjousTabText = lazy(() => import("./TabTarjous/Tab/TarjousTabText"));
const ViestitTabText = lazy(() => import("./TabViestit/components/ViestitTabText"));

const _jaa = import("./TabJaa/TabJaa");
const Jaa = lazy(() => _jaa);

const _kuvat = import("./TabKuvat/TabKuvat");
const TabKuvat = lazy(() => _kuvat);

const _stepProcess = import("../StepProcess/StepProcess");
const StepProcess = lazy(() => _stepProcess);

const _viestit = import("./TabViestit/TabViestit");
const Viestit = lazy(() => _viestit);

const _tabHinta = import("./TabHinta/TabHinta");
const TabHinta = lazy(() => _tabHinta);

const _tabAsetukset = import("./TabAsetukset/TabAsetukset");
const TabAsetukset = lazy(() => _tabAsetukset);

// this is injected as classes prop into the wrapping component
let tabStyle = {
  minWidth: 0,
  paddingLeft: "10px",
  paddingRight: "10px",
};

export default function StepTilausTabs(props) {
  const value = props.value;
  const { doSetTabValue: setTabValue } = useNavData();
  const { isLoaded: tarjousIsLoaded } = useTarjousData();
  const { user, auth } = useUserData();
  const { keikkaData, doSetKeikkaData: setKeikkaData } = useKeikkaData();

  const { stepLog } = useStepLogData();
  const [edgeDrawerIsOpen, setDrawerIsOpen] = useState(false);
  const navigate = useNavigate();

  const { toimitus } = useToimitusData();

  const handleTabChange = (event, newValue) => setTabValue(newValue);
  const handleEdgeDrawerClose = () => setDrawerIsOpen(!edgeDrawerIsOpen);
  const handleEdgeDrawerClick = (e) => setTabValue(e);
  const handleKeikkaDeleted = () => navigate("/", { replace: true });
  if (!keikkaData) return <>NO KEIKKADATA</>;
  const keikkaAuth = auth.keikkaDataAuth(keikkaData);

  return (
    <>
      <EdgeDrawer
        open={edgeDrawerIsOpen}
        onClose={handleEdgeDrawerClose}
        onClick={handleEdgeDrawerClick}
      />
      <div>
        {props.isAuthenticated && (
          <div className="harmaaTausta noPrint">
            <div
              style={{
                width: "100%",
                borderBottom: 2,
                borderColor: "divider",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <Paper elevation={3} sx={{ width: "100%" }}>
                <div
                  className="spaceBetween"
                  style={{ boxShadow: "0px 0px 30px 30px rgba(128, 128, 128, 0.4) inset" }}>
                  <Button
                    onClick={handleEdgeDrawerClose}
                    variant="text"
                    sx={{ height: "36px", zIndex: 4 }}>
                    <EdgeDrawerIcon fontSize={"16px"} />
                  </Button>
                  <MyTabs value={value} onChange={handleTabChange} transparent>
                    {
                      // tilaus tab
                      <Tab
                        value={0}
                        style={tabStyle}
                        label={
                          <TilausTabText
                            isActive={value == 0}
                            isLoading={
                              !toimitus ||
                              !toimitus.isLoaded ||
                              !stepLog?.isLoaded ||
                              keikkaData.isLoading
                            }
                          />
                        }
                        {...a11yProps(0)}
                      />
                    }
                    {
                      // toimitus tab
                      keikkaAuth.modules.toimitus.read && (
                        <Tab
                          value={7}
                          style={tabStyle}
                          label={
                            <LazyLoader>
                              <ToimitusTabText
                                isLoading={!toimitus.isLoaded}
                                isActive={value == 7}
                              />
                            </LazyLoader>
                          }
                          {...a11yProps(7)}
                        />
                      )
                    }
                    {keikkaAuth.modules.kuvat.read && (
                      // kuvat tab
                      <Tab
                        value={4}
                        style={tabStyle}
                        label={<KuvaTabText isActive={value == 4} />}
                        {...a11yProps(4)}
                      />
                    )}
                    {value == 1 && keikkaAuth.toiminnot.read && (
                      // toiminnot tab
                      <Tab
                        value={1}
                        style={tabStyle}
                        label={
                          <LazyLoader>
                            <ToiminnotTabText isActive={value == 1} />
                          </LazyLoader>
                        }
                        {...a11yProps(1)}
                      />
                    )}
                    {value == 3 &&
                      keikkaAuth.viestit.read && ( // show only when active, selected from EdgeDrawer
                        // viestit tab
                        <Tab
                          value={3}
                          style={tabStyle}
                          label={
                            <LazyLoader txt={"Ladataan ViestitTabText"}>
                              <ViestitTabText keikkaData={keikkaData} isActive={value == 3} />
                            </LazyLoader>
                          }
                          {...a11yProps(3)}
                        />
                      )}
                    {value == 5 && (
                      <Tab
                        value={5}
                        style={tabStyle}
                        sx={{ padding: "0px", margin: "0px" }}
                        label={
                          <LazyLoader txt={"Ladataan ViestitTabText"}>
                            <ProcessTabText keikkaData={keikkaData} isActive={value == 5} />
                          </LazyLoader>
                        }
                        {...a11yProps(5)}
                      />
                    )}
                    {
                      // tarjous tab
                      keikkaAuth.modules.tarjous.read && (
                        <Tab
                          value={9}
                          style={tabStyle}
                          label={
                            <LazyLoader>
                              <TarjousTabText isLoading={!tarjousIsLoaded} isActive={value == 9} />
                            </LazyLoader>
                          }
                          {...a11yProps(9)}
                        />
                      )
                    }
                    {keikkaAuth.modules.lasku.read && (
                      <Tab
                        value={6}
                        style={tabStyle}
                        label={
                          <LazyLoader>
                            <HintaTabText isActive={value == 6} />
                          </LazyLoader>
                        }
                        {...a11yProps(6)}
                      />
                    )}
                    {value == 8 && (
                      <Tab
                        value={8}
                        style={tabStyle}
                        label={
                          <LazyLoader>
                            <AsetuksetTabText isActive={value == 8} />
                          </LazyLoader>
                        }
                        {...a11yProps(8)}
                      />
                    )}
                  </MyTabs>
                  <div style={{ display: "flex" }}>
                    {keikkaAuth.action.delete && (
                      <div className="onlyWide" style={{ opacity: 0.7 }}>
                        <LazyLoader>
                          <DeleteKeikkaIcon
                            className="tabIcon"
                            keikkaData={keikkaData}
                            setKeikkaData={setKeikkaData}
                            keikkaDeleted={handleKeikkaDeleted}
                          />
                        </LazyLoader>
                      </div>
                    )}
                    <div style={{ paddingTop: "10px", paddingRight: "3px" }}>
                      <KeikkaConnectedIcon />
                    </div>
                  </div>
                </div>
              </Paper>
            </div>
          </div>
        )}
        <TabPanel value={value} index={0}>
          <StepTilaus {...props} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <LazyLoader>
            <Jaa />
          </LazyLoader>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <LazyLoader>{keikkaAuth.viestit.read && <Viestit keikkaData={keikkaData} />}</LazyLoader>
        </TabPanel>
        <TabPanel value={value} index={4}>
          <LazyLoader>
            <TabKuvat
              keikkaId={keikkaData.keikkaId}
              allowAdd={true}
              allowDelete={keikkaData.auth.originalEdit && keikkaData.keikkaTilaId !== 100}
              showPumiFiAttachments={showPumiFiAttachments(keikkaData, stepLog)}
              foreignKey={keikkaData.foreignKey}
              ownerAsiakasId={keikkaData.ownerAsiakasId}
            />
          </LazyLoader>
        </TabPanel>
        <TabPanel value={value} index={5}>
          <LazyLoader>
            <StepProcess {...props} />
          </LazyLoader>
        </TabPanel>
        <TabPanel value={value} index={9}>
          <LazyLoader>{keikkaAuth.modules.tarjous.read && <TabTarjous />}</LazyLoader>
        </TabPanel>
        <TabPanel value={value} index={6}>
          <LazyLoader>{keikkaAuth.modules.lasku.read && <TabHinta />}</LazyLoader>
        </TabPanel>
        <TabPanel value={value} index={7}>
          <LazyLoader>{keikkaAuth.modules.toimitus.read && <TabToimitus />}</LazyLoader>
        </TabPanel>
        <TabPanel value={value} index={8}>
          <LazyLoader>{user.isSystemAdmin && <TabAsetukset />}</LazyLoader>
        </TabPanel>
      </div>
    </>
  );
}

StepTilausTabs.propTypes = {
  isAuthenticated: PropTypes.bool,
  navTo: PropTypes.func,
  value: PropTypes.number,
  stepId: PropTypes.number,
};
